import moment from 'moment';
import Api from '../Api';
import { parseUnits, formatHash } from '../utils';
import { closeModal } from '../modal';

export function createModalApp(selector, coin, wallet) {
    PetiteVue.createApp({
        coin,
        walletEdited: wallet || "",
        rigId: "",
        region: 'eu',
        visibility: 'normal',
        hasCustomMsg: false,
        coinbaseMsg: '',
        emailNotif: '',
        diff: 'auto',

        showConfig: false,

        async copyText(textx) {
            try {
                await navigator.clipboard.writeText(textx);
                // toast("Copied!", { type: "success" })
            } catch ($e) {
                alert('Cannot copy');
            }
        },

        close() {
            closeModal(selector);
        },

        sendConversion() {
            if (window.gtag) {
                window.gtag('event', 'ads_conversion_Rejestracja_1', {});
            }
        },

        get stratumUrl() {
            let port = 3333;
            let serverId = '1';
            if (this.coin == 'btc') port = 3332;
            if (this.coin == 'bch') port = 3334;
            if (this.coin == 'rvn') port = 3336;
            else if (this.coin == 'dgb') {
                port = 3335;
                // serverId = '2'; // DGB is only on #2 server for now
            }
            return `stratum+tcp://stratum-${this.region}${serverId}.minemine.online:${port}`;
        },

        get pass() {
            const opt = [];
            opt.push('diff=' + this.diff);

            const msg = this.coinbaseMsg.replaceAll(';', '').replaceAll('"', '').trim();
            if (this.hasCustomMsg && msg) {
                opt.push('msg=' + msg);
            }

            if (this.visibility == 'private') {
                opt.push('priv=1');
            }

            if (this.emailNotif.includes('@')) {
                opt.push('notif=' + this.emailNotif);
            }

            return opt.join(';');
        }
    }).mount(selector);
}